import { Link as RouterLink } from "react-router-dom";

type Props = React.PropsWithChildren<{
  href: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler;
  target?: string;
  rel?: string;
}>;

export default function Link({ href, children, ...rest }: Props) {
  return (
    <RouterLink to={href} {...rest}>
      {children}
    </RouterLink>
  );
}
